import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11l-3 3l-3 -3","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedChevronDown = createReactComponent('outline', 'square-rounded-chevron-down', 'SquareRoundedChevronDown', __iconNode);

export default IconSquareRoundedChevronDown;